import React from "react";
import SubHeader from "../../../common/subHeader";
import ATable from "../../../common/table";
import Formsy from "formsy-react";
import Toaster from "toastr";
import Util from "../../../../util/util";
import Messages from "../../../../configurations/messages";
import TextInput from "../../common/controls/TextInput";
import { DiscoverFields } from "../../../../configurations/discoverConfigs/fields";
import DiscoverApi from "../../../../api/DiscoverApi";
import { Spinner } from "../../../common/spinner";
import { DiscoverConstants } from "../../../../configurations/discoverConfigs/discoverConstants";
class CaseNotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
      sending: false,
      showAddCaseNote: false
    };
    this.enableButton = this.enableButton.bind(this);
    this.disableButton = this.disableButton.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.showAddCaseNote = this.showAddCaseNote.bind(this);
  }
  disableButton() {
    this.setState({ canSubmit: false });
  }

  enableButton() {
    this.setState({ canSubmit: true });
  }

  showAddCaseNote() {
    this.setState(prevState => ({
      showAddCaseNote: !prevState.showAddCaseNote
    }));
  }

  handleSubmit(data) {
    this.setState({ sending: true });
    DiscoverApi.createCaseNote(data, this.props.caseDetails.caseNumber)
      .then(response => {
        Toaster.success(Messages.SUCCESS_CASE_NOTE);
        this.setState({
          sending: false
        });
        this.props.getCaseDetails(this.props.caseDetails.caseNumber);
        this.showAddCaseNote();
      })
      .catch(error => {
        this.setState({ sending: false });
        Util.errorMessageToast(Toaster, error.data.description, [
          `${Messages.ERROR_CASE_NOTE}`
        ]);
      });
  }

  render() {
    const { caseDetails, casePermissions } = this.props;
    const { canSubmit, showAddCaseNote, sending } = this.state;
    const columns = [
      {
        header: "Note",
        accessor: "note",
        width: 500
      },
      {
        header: "Added By",
        accessor: "addedBy"
      },
      {
        header: "Added On",
        accessor: "addedOn"
      }
    ];
    return (
      <div>
        <div className="row">
          <div className="col-sm-8">
            <SubHeader title="Case Notes" />
          </div>
          {}
          <div className="col-sm-4 text-right">
            {casePermissions.indexOf(
              DiscoverConstants.caseUpdatePermissions.addCaseNote
            ) >= 0 ? (
              <button
                className="btn btn-primary"
                onClick={this.showAddCaseNote}
              >
                {!showAddCaseNote ? "Add Case Note" : "View Case Notes"}
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
        <hr />
        {showAddCaseNote && (
          <div className="row">
            <div className="col-xs-12">
              <div className="panel panel-default">
                <div className="panel-body">
                  <Formsy
                    onValidSubmit={this.handleSubmit}
                    onValid={this.enableButton}
                    onInvalid={this.disableButton}
                    ref="addCaseNote"
                    noValidate
                  >
                    <TextInput
                      name={DiscoverFields.caseNote.name}
                      label={DiscoverFields.caseNote.label}
                      description={DiscoverFields.caseNote.description}
                      validations={{
                        maxLength: DiscoverFields.caseNote.maxLength
                      }}
                      validationErrors={{
                        maxLength: `Maximum of ${
                          DiscoverFields.caseNote.maxLength
                        } characters allowed`
                      }}
                      required
                      placeHolder={DiscoverFields.caseNote.label}
                      multiline={
                        DiscoverFields.caseNote.maxLength >= 200 && true
                      }
                    />
                    <button
                      className="btn btn-primary"
                      disabled={!canSubmit || sending}
                    >
                      {sending ? <Spinner color="#FFF" /> : "Submit Case Note"}
                    </button>
                  </Formsy>
                </div>
              </div>
            </div>
          </div>
        )}

        {caseDetails &&
          caseDetails.caseNotes &&
          !showAddCaseNote && (
            <ATable
              className="-striped -highlight"
              tableData={caseDetails.caseNotes}
              columns={columns}
              defaultPageSize={10}
              onRowClick={() => null}
              SubComponent={rowObject => {
                return (
                  <div
                    className="panel panel-default"
                    style={{ marginBottom: 0 }}
                  >
                    <div className="panel-body">
                      <h4 className="bold" style={{ marginTop: 0 }}>
                        Note
                      </h4>
                      {rowObject.row.note}
                    </div>
                  </div>
                );
              }}
            />
          )}
      </div>
    );
  }
}

export default CaseNotes;



// WEBPACK FOOTER //
// ./src/components/discover/cases/caseDetail/CaseNotes.js